// extracted by mini-css-extract-plugin
export default {"root":"SendApplicationInvoiceModal_root__PqbLR","sub-header":"SendApplicationInvoiceModal_sub-header__-I-fD"};